function RetailersMap() {
    return (
        <iframe src='https://www.google.com/maps/d/embed?mid=1MEolzTxyv46yF4_wawAR3ulVLQ_IlrN6' width='640'
                height='480'></iframe>
    )
}

export default RetailersMap